import request from '@/utils/httpRequest'

export default class invoiceFlowService {
    queryByIdAndType(id, type) {
        return request({
            url: '/cost/invoice/queryByIdAndType',
            method: 'get',
            params: {
                id: id,
                type: type
            }
        })
    }
}